import * as React from 'react';
import { reduxForm, Field, SubmissionError } from 'redux-form';
import { debug } from '../../../utils';
import Button from '../../components/Button/Button';
import { TextField } from '../../components/fields';
const styles = require('./styles.less') as any;
const log = debug('lego:ChangeEmailForm.tsx');

const validate = values => {
	const errors = {};
	const requiredFields = [ 'new_email', 'password', 'confirm_email' ];
	requiredFields.forEach(field => {
		if (!values[field]) { errors[ field ] = 'Required'; }
	});
	if (values.new_email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.new_email)) {
		errors['new_email'] = 'Invalid email address';
	}
	if (values.confirm_email !== values.new_email) { errors['confirm_email'] = 'Email Addresses must match'; }
	return errors;
}

import { handleSubmissionError } from '../utils'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
export default reduxForm({form: 'ChangeEmailForm', validate})(({ handleSubmit, changeEmail, pristine, submitting, reset, cancel, error }) => {
  const cancelHandler = (...args) => {
    cancel();
    return reset(...args);
  };

	const _changeEmail = values =>
		handleSubmissionError(changeEmail)({new_email: values['new_email']})
			.then(cancelHandler)

  return (
    <form onSubmit={handleSubmit(_changeEmail)}>
      <Field name='new_email' component={TextField} autoCapitalize='none'
						 label='New Email' type='email' placeholder="you@youremail.com" />
      <Field name='confirm_email' component={TextField}
						 label='Confirm New Email' autoCapitalize='none' type='email' placeholder="you@yourdomain.com" />
      <Field name='password' type='password' component={TextField} label='Password' placeholder="Your Password" />
			{error && <div><strong>{error}</strong></div>}
      <div>
        <Button type="button" kind="secondary" disabled={submitting} onClick={cancelHandler}>Cancel</Button>
        <Button type="submit" disabled={pristine || submitting}>Submit</Button>
      </div>
    </form>
  );
});



// WEBPACK FOOTER //
// ./src/app/containers/Account/ChangeEmailForm.tsx